import cn from 'classnames'
import type { CSSProperties, FC } from 'react'

import css from './Delimiter.css'

type DelimiterProps = {
  className?: string
  position?: 'vertical' | 'horizontal'
  size?: CSSProperties['width' | 'height']
}

/**
 * Простейший разделитель-чёрточка
 *
 * Имеет публичное css свойство `--delimiter-size: <length>`, которое влияет на размер разделителя
 * Разделитель может быть в двух позициях: вертикальный и горизонтальный
 */
export const Delimiter: FC<DelimiterProps> = ({ className, position = 'vertical', size }) => {
  return (
    <div
      className={cn(css.delimiter, className, {
        [css.horizontal]: position === 'horizontal',
      })}
      role="separator"
      style={{ '--delimiter-size': size }}
      tabIndex={-1}
    />
  )
}
